module.exports = __webpack_public_path__ + "static/media/Sorghum4-5.e8f465d0.PNG";